/* eslint-disable no-console */
import { Text } from '@leverege/ui-elements';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Attributes } from '@leverege/ui-attributes';
import P from '@leverege/promise';
import { Blocker } from '@leverege/molten/views';
import { ParentUtil, ItemDelegate } from '@leverege/molten/imagine';
import { jsx as _jsx } from "react/jsx-runtime";
function BillLocationIntercomIdRenderer(props) {
  const {
    original
  } = props;
  const dispatch = useDispatch();
  const initialLoad = useRef(P.deferred());
  const attr = Attributes.getAttribute('bill.location', 'bill');
  const parentAction = ParentUtil.getParentAction(original, attr);
  const locationId = attr.get(original.data);
  const item = useSelector(state => ItemDelegate.getItem(locationId));
  useEffect(() => {
    if (!locationId) {
      return () => null;
    }
    let isActive = true;
    const dispatchData = async () => {
      try {
        await dispatch(parentAction.item(locationId).get({
          ttl: 300000
        }));
        if (isActive) {
          initialLoad.current.resolve();
        }
      } catch (err) {
        console.error('Error fetching location data', err);
      }
    };
    dispatchData();
    return () => {
      isActive = false;
    };
  }, [dispatch, locationId, parentAction]);
  const renderChildren = useCallback(() => {
    const intercomId = item?.data?.intercom?.Dealership_Location_KudelskiID;
    return intercomId ? /*#__PURE__*/_jsx(Text, {
      variant: "columnValue",
      children: intercomId
    }) : null;
  }, [item]);
  return /*#__PURE__*/_jsx(Blocker, {
    matchContext: {
      client: 'BillLocationIntercomIdRenderer'
    },
    context: props,
    hooks: [{
      execute: () => initialLoad
    }],
    render: renderChildren,
    small: true,
    loadingProps: {
      inline: true
    }
  });
}
export default BillLocationIntercomIdRenderer;